import React, { memo } from 'react';
import { LinearGradient } from 'expo-linear-gradient';

import { COLORS } from '@bcm/constants';
import commonStyles from './styles/common';

const GradientBackground = ({
	colorStart,
	colorStop,
	color,
	invertGradient,
	style,
	children,
}) => {
	let colors = (colorStart && colorStop) ? [colorStart, colorStop]
		: (color === COLORS.white) ? [COLORS.white, COLORS.offWhite]
			: (color === COLORS.textError) ? [COLORS.textError, COLORS.accent]
				: [COLORS.light, COLORS.lightOffset];
	if (invertGradient) colors = [colors[1], colors[0]];
	return (
		<LinearGradient
			colors={colors}
			start={[0, 0.5]}
			style={(style) ? style : commonStyles.screen}
		>
			{children}
		</LinearGradient>
	);
};

export default memo(GradientBackground);